import { createFileRoute } from "@tanstack/react-router";
import OwnerAiUsagePage from "@/pages/OwnerAiUsagePage";

export const Route = createFileRoute("/_owner/owner/ai-usage")({
  component: OwnerAiUsagePage,
});
